import { FEE_APPLICABILITIES } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(FEE_APPLICABILITIES);
    }
}